import React from 'react';
import { css } from '@emotion/react';
import { IGetResidentGasDetaSetsRes} from "@/types/api/bDevice/residentGasDataSets";
import dayjs from 'dayjs';
import { Button } from '@/components/mui/button';
import { useTranslation } from 'react-i18next';

interface Props {
  dataset: IGetResidentGasDetaSetsRes;
  addGraph: (start: string, end: string) => void;
  updateGraph: (start: string, end: string) => void;
}

const Container = css`
  padding: 12px;
  margin-bottom: 16px;
  border: 1px solid #cccccc;
  border-radius: 4px;
`;

const ButtonContainer = css`
  display: flex;
  align-items: center;
  gap: 0 4px;
`;

export const DataSetListItem = React.memo(({ dataset, addGraph, updateGraph }: Props) => {
  const { t } = useTranslation();
  const handleClickAddGraph = React.useCallback(() => {
    addGraph(dataset.startDateTime, dataset.endDateTime);
  }, []);

  const handleClickupdateGraph = React.useCallback(() => {
    updateGraph(dataset.startDateTime, dataset.endDateTime);
  }, []);

  return (
    <div css={Container}>
      <div>{dayjs(dataset.startDateTime).format('YYYY/MM/DD HH:mm:ss')}~</div>
      <div css={ButtonContainer}>
        <Button onClick={handleClickAddGraph}>{t('addGraph', 'グラフ追加')}</Button>
        <Button variant='contained' onClick={handleClickupdateGraph}>
          {t('view', '表示')}
        </Button>
      </div>
    </div>
  );
});
